module.exports = __webpack_public_path__ + "img/historia4.35c94001.jpg";